import styled from '@emotion/styled'
import React from 'react'

interface Props {
    width: number
    height: number
}
const SingleCheckIcon: React.FC<Props> = ({ width, height }) => {
    return <Icon width={width} height={height} />
}

export default SingleCheckIcon

const Icon = styled.i<{ width: number; height: number }>`
    display: inline-block;
    width: ${({ width }) => (width ? width : 18)}px;
    height: ${({ height }) => (height ? height : 18)}px;
    background-image: url('/icon/ColorCheck.svg');
`
